import { Button, Group, Loader, SegmentedControl, Stack, Title } from '@mantine/core';
import { YearPickerInput } from '@mantine/dates';
import moment from 'moment';
import { useState } from 'react';

import { EORIGIN_DATE_FORMAT } from '@e-origin/shared';

import { DatePickerInput } from '@components';
import { useGenerateCBAMReport } from '@hooks/batch';

export const CBAMReportForm = () => {
  const [searchType, setSearchType] = useState<'date' | 'year'>('date');
  const [startDate, setStartDate] = useState(moment().toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const [selectedYear, setSelectedYear] = useState<Date | null>(moment().toDate());

  const generateCBAMReportMutation = useGenerateCBAMReport();
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerateReport = async () => {
    setIsLoading(true);

    if (searchType === 'year') {
      await generateCBAMReportMutation.mutateAsync({
        year: moment(selectedYear).format('YYYY'),
      });
    } else {
      await generateCBAMReportMutation.mutateAsync({
        startDate: moment(startDate).format(EORIGIN_DATE_FORMAT),
        endDate: moment(endDate).format(EORIGIN_DATE_FORMAT),
      });
    }

    setIsLoading(false);
  };

  return (
    <Stack gap="xl">
      <Title order={2}>CBAM Report</Title>

      <SegmentedControl
        value={searchType}
        onChange={(value) => setSearchType(value as 'date' | 'year')}
        data={[
          { label: 'By date range', value: 'date' },
          { label: 'By year', value: 'year' },
        ]}
        w={300}
      />

      {searchType === 'date' ? (
        <>
          <DatePickerInput label="Start date" value={startDate} onChange={(value: Date) => setStartDate(value)} clearable={true} w={300} />
          <DatePickerInput label="End date" value={endDate} onChange={(value: Date) => setEndDate(value)} clearable={true} w={300} />
        </>
      ) : (
        <YearPickerInput value={selectedYear} onChange={setSelectedYear} clearable={true} w={300} />
      )}

      <Group>
        <Button leftSection={isLoading && <Loader color="white" />} onClick={handleGenerateReport} disabled={isLoading} variant="filled" size="lg">
          Generate report
        </Button>
      </Group>
    </Stack>
  );
};
